module.exports = __webpack_public_path__ + "static/media/So Many Issues.45a64bbf.jpg";